import React, { FC } from "react";
import { CardMedia as MuiCardMedia, CardMediaProps } from "@mui/material";

const CardMedia: FC<CardMediaProps> = (props) => <MuiCardMedia {...props} />;

export default CardMedia;
